import { experiments } from "@/utils/experiment";

import {
    queryParam,
    user,
    localStorageData
} from "../../hooks/use-registered-metadata";

import {
    JTBD,
    PROVISIONING,
    ScreenConfig,
    TEAM_CHOICE,
    TEMPLATE_CHOICE,
    PROVISIONING_WITH_WIZARD,
    RESOLVE_TENANT_LOADER,
    MADLIB_PROJECT_SETUP,
    JIRA_FFL_PROVISIONING_GATE
} from "./utils";

export const jiraScreenConfig: ScreenConfig = {
    [JIRA_FFL_PROVISIONING_GATE]: {
        position: { default: 10 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: queryParam.jiraFflCgsKeyExists,
                            value: true
                        },
                        {
                            type: "experiment",
                            experiment: experiments.cfind4666JiraFfl,
                            value: true
                        }
                    ]
                }
            ]
        }
    },
    [RESOLVE_TENANT_LOADER]: {
        position: { default: 50 },
        onMount: () => undefined,
        visibility: {
            default: true
        }
    },
    [TEAM_CHOICE]: {
        position: { default: 100 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: queryParam.templateId,
                            value: undefined
                        },
                        {
                            key: queryParam.products,
                            value: ["jira-software.ondemand"]
                        },
                        {
                            conditionalOR: [
                                {
                                    conditionalAND: [
                                        {
                                            key: user.isN2n,
                                            value: true
                                        }
                                    ]
                                },
                                {
                                    conditionalAND: [
                                        {
                                            key: user.isExistingJiraUser,
                                            value: false
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            conditionalOR: [
                                {
                                    conditionalAND: [
                                        {
                                            key: localStorageData.team,
                                            value: undefined
                                        }
                                    ]
                                },
                                {
                                    conditionalAND: [
                                        {
                                            key: localStorageData.team,
                                            value: ""
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    },
    [JTBD]: {
        position: { default: 190 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: user.isN2n,
                            value: true
                        },
                        {
                            key: queryParam.jtbd,
                            value: undefined
                        },
                        {
                            conditionalOR: [
                                {
                                    conditionalAND: [
                                        {
                                            key: queryParam.products,
                                            value: ["jira-software.ondemand"]
                                        }
                                    ]
                                },
                                {
                                    conditionalAND: [
                                        {
                                            key: queryParam.products,
                                            value: ["jira-core.ondemand"]
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            key: queryParam.templateId,
                            value: undefined
                        }
                    ]
                }
            ]
        }
    },
    [TEMPLATE_CHOICE]: {
        position: { default: 200 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: queryParam.templateId,
                            value: undefined
                        },
                        {
                            key: queryParam.templateChoice,
                            value: undefined
                        },
                        {
                            key: queryParam.jtbd,
                            value: undefined
                        },
                        {
                            key: queryParam.products,
                            value: ["jira-software.ondemand"]
                        }
                    ]
                }
            ]
        }
    },
    [MADLIB_PROJECT_SETUP]: {
        position: { default: 250 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            type: "experiment",
                            experiment: experiments.jiraOnboardingAiMadlibV2,
                            value: true
                        }
                    ]
                }
            ]
        }
    },
    [PROVISIONING]: {
        position: { default: 300 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: user.isMobile,
                            value: true
                        }
                    ]
                }
            ]
        }
    },
    [PROVISIONING_WITH_WIZARD]: {
        position: { default: 300 },
        onMount: () => undefined,
        visibility: {
            default: false,
            conditionalOR: [
                {
                    conditionalAND: [
                        {
                            key: user.isMobile,
                            value: false
                        }
                    ]
                }
            ]
        }
    }
};
